module.exports = __webpack_public_path__ + "img/icon-delete-btn.c825301a.svg";